/**
 * Símbolo do produto.
 *
 * Substitui o `GrStationMark` (as três barras curvas), que era o logotipo da GR
 * e não podia sobreviver num produto white label.
 *
 * Se a instalação define um símbolo próprio (`symbolUrl`), renderiza ele.
 * Senão cai numa marca vetorial NEUTRA — duas bolhas de conversa —, desenhada
 * para não pertencer a marca nenhuma. Usa `currentColor`, então herda a cor do
 * contexto e adapta a tema claro/escuro, igual ao símbolo antigo fazia.
 */
export function ProductMark({
  className,
  size = 18,
  symbolUrl = null,
  title = 'Símbolo do produto',
}: {
  className?: string
  size?: number
  symbolUrl?: string | null
  title?: string
}) {
  if (symbolUrl) {
    return (
      <img
        src={symbolUrl}
        alt={title}
        width={size}
        height={size}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    )
  }

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="currentColor"
      role="img"
      aria-label={title}
    >
      {/* bolha de trás (a que fala) */}
      <path d="M8.4 2.6h9.2A3.9 3.9 0 0 1 21.5 6.5v5.2a3.9 3.9 0 0 1-3.9 3.9h-.6v2.6a.9.9 0 0 1-1.5.66l-1.9-1.7V6.5A3.9 3.9 0 0 1 17.5 2.6Z" opacity=".45" />
      {/* bolha da frente (a que responde) */}
      <path d="M6.4 5.2h8.1a3.6 3.6 0 0 1 3.6 3.6v5.1a3.6 3.6 0 0 1-3.6 3.6H9.9l-3.6 3.2a.85.85 0 0 1-1.42-.63v-2.57h-.02A3.6 3.6 0 0 1 1.3 13.9V8.8a3.6 3.6 0 0 1 3.6-3.6Z" />
    </svg>
  )
}
